export default __webpack_public_path__ + "images/6F.27b6cba.png";